const question = [
    {
        path: "/question/manage",
        name: "questionManage",
        component: () => import("@/view/question/manage"),
    },
    {
        path: "/question/test",
        name: "questionTest",
        component: () => import("@/view/question/test"),
    },
    {
        path: "/question/record",
        name: "questionRecord",
        component: () => import("@/view/question/record"),
    },
];
export default question;
